import React from 'react';
import { ToolTipTemplateProps, ToolTip } from '../interfaces';

export const ToolTipBasicTemplate = (props: ToolTipTemplateProps) => {
  return (
    <div className={props.className}>
      {props.tips.map((tip: ToolTip, index: number) => {
        return (
          <div className={`tip-message tip-${tip.type}`} key={index}>
            {tip.message}
          </div>
        );
      })}
    </div>
  );
};
